import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {fetchWrapper} from "_helpers";

// create slice

const name = "users";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({name, initialState, extraReducers});

// exports

export const userActions = {...slice.actions, ...extraActions};
export const usersReducer = slice.reducer;

// implementation

function createInitialState() {
	return {
		user: {},
		users: {},
		userAdd: {},
		userEdit: {},
	};
}

function createExtraActions() {
	const baseUrl = `${process.env.REACT_APP_API_URL}/users`;

	return {
		get: get(),
		getAll: getAll(),
		add: add(),
		edit: edit(),
	};

	function get() {
		return createAsyncThunk(`${name}/get`, async id => await fetchWrapper.get(`${baseUrl}/${id}`));
	}
	function add() {
		return createAsyncThunk(`${name}/add`, async data => await fetchWrapper.post(`${baseUrl}/register`, data.data));
	}
	function edit() {
		return createAsyncThunk(`${name}/edit`, async data => await fetchWrapper.put(`${baseUrl}`, data.data));
	}
	function getAll() {
		return createAsyncThunk(`${name}/getAll`, async () => await fetchWrapper.get(baseUrl));
	}
}

function createExtraReducers() {
	return {
		...getAll(),
		...get(),
		...add(),
		...edit(),
	};

	function getAll() {
		var {pending, fulfilled, rejected} = extraActions.getAll;
		return {
			[pending]: state => {
				state.users = {loading: true};
			},
			[fulfilled]: (state, action) => {
				state.users = action.payload;
			},
			[rejected]: (state, action) => {
				state.users = {error: action.error};
			},
		};
	}
	function get() {
		var {pending, fulfilled, rejected} = extraActions.get;
		return {
			[pending]: state => {
				state.user = {loading: true};
			},
			[fulfilled]: (state, action) => {
				state.user = action.payload;
			},
			[rejected]: (state, action) => {
				state.user = {error: action.error};
			},
		};
	}
	function add() {
		var {pending, fulfilled, rejected} = extraActions.add;
		return {
			[pending]: state => {
				state.userAdd = {loading: true};
			},
			[fulfilled]: (state, action) => {
				state.userAdd = action.payload;
			},
			[rejected]: (state, action) => {
				state.userAdd = {error: action.error};
			},
		};
	}
	function edit() {
		var {pending, fulfilled, rejected} = extraActions.edit;
		return {
			[pending]: state => {
				state.userEdit = {loading: true};
			},
			[fulfilled]: (state, action) => {
				state.userEdit = action.payload;
			},
			[rejected]: (state, action) => {
				state.userEdit = {error: action.error};
			},
		};
	}
}
